import { Injectable } from '@angular/core';

import { DocumentService } from './document.service';

@Injectable({
    providedIn: 'root'
})
export class PageVisibilityService {

    constructor(
        private readonly documentService: DocumentService) {
    }

    public addOnVisibilityChanged(handler: (visibilityState: VisibilityState) => void): void {
        const nativeDocument = this.documentService.nativeDocument;
        nativeDocument.addEventListener('visibilitychange', () => handler(nativeDocument.visibilityState));
    }

    public getVisibilityState(): VisibilityState {
        return this.documentService.nativeDocument.visibilityState;
    }

    public isVisible(): boolean {
        return this.getVisibilityState() === 'visible';
    }
}
